module.exports = __webpack_public_path__ + "8382c1ad69bcd277be531c52568cc201.svg";